if (!customElements.get("animated-image-collage")) {
  customElements.define(
    "animated-image-collage",
    class AnimatedImageCollage extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          container: this.querySelector(".animated-image-collage__container"),
          textContent: this.querySelector('.animated-image-collage__container--content--text'),
          firstImage: this.querySelector(".animated-image-collage__image:nth-child(1)"),
          secondImage: this.querySelector(".animated-image-collage__image:nth-child(2)"),
          thirdImage: this.querySelector(".animated-image-collage__image:nth-child(3)"),
          fourthImage: this.querySelector(".animated-image-collage__image:nth-child(4)"),
          fifthImage: this.querySelector(".animated-image-collage__image:nth-child(5)"),
          sixthImage: this.querySelector(".animated-image-collage__image:nth-child(6)")
        };
      }

      connectedCallback() {
        this.addEventListeners();
      }

      addEventListeners() {
        window.addEventListener("scroll", () => {
          requestAnimationFrame(() => {
            const percent = this.getScrollPercentIntoSection();

            this.translateContainer(percent);

            // animate text content in and out
            if(percent > 10) {
              this.elements?.textContent?.classList.add('animated-in');
            } else {
              this.elements?.textContent?.classList.remove('animated-in');
            }

            if(window.innerWidth >= 750){
            if (percent > 30) {
              this.elements?.firstImage?.classList.add("animated");
              this.elements?.secondImage?.classList.add("animated");
              this.elements?.thirdImage?.classList.add("animated");
            } else {
              this.elements?.firstImage?.classList.remove("animated");
              this.elements?.secondImage?.classList.remove("animated");
              this.elements?.thirdImage?.classList.remove("animated");
            }
            if (percent > 50) {
              this.elements?.fourthImage?.classList.add("animated");
              this.elements?.fifthImage?.classList.add("animated");
              this.elements?.sixthImage?.classList.add("animated");
            } else {
              this.elements?.fourthImage?.classList.remove("animated");
              this.elements?.fifthImage?.classList.remove("animated");
              this.elements?.sixthImage?.classList.remove("animated");
            }
            } else {
              if (percent > 30) {
                this.elements?.firstImage?.classList.add("animated");
                this.elements?.secondImage?.classList.add("animated");

              } else {
                this.elements?.firstImage?.classList.remove("animated");
                this.elements?.secondImage?.classList.remove("animated");

              }
              if (percent > 40) {
                this.elements?.thirdImage?.classList.add("animated");
                this.elements?.fourthImage?.classList.add("animated");

              } else {
                this.elements?.thirdImage?.classList.remove("animated");
                this.elements?.fourthImage?.classList.remove("animated");

              }
              if (percent > 50) {
                this.elements?.fifthImage?.classList.add("animated");
                this.elements?.sixthImage?.classList.add("animated");
              } else {
                this.elements?.fifthImage?.classList.remove("animated");
                this.elements?.sixthImage?.classList.remove("animated");
              }
            }
          });
        });
      }

      getScrollPercentIntoSection() {
        // respect browser ainmation limit

        const rect = this.getBoundingClientRect();
        const sectionHeight = this.offsetHeight;
        const windowHeight = window.innerHeight;

        // Section is completely above the viewport
        if (rect.bottom <= 0) {
          return 100;
        }

        // Section is completely below the viewport
        if (rect.top >= windowHeight) {
          return 0;
        }

        // Section is fully visible or has been fully visible and is partially scrolled past
        if (rect.top <= 0 && rect.bottom >= windowHeight) {
          return 100;
        }

        if (rect.top <= 0) {
          return 100;
        }

        // Section is partially visible (entering or leaving)
        const visibleTop = Math.max(0, rect.top);
        const visibleBottom = Math.min(windowHeight, rect.bottom);
        const visibleHeight = visibleBottom - visibleTop;

        const percent = (visibleHeight / sectionHeight) * 100;
        return Math.min(100, Math.max(0, percent));
      }

      translateContainer(percent, speed = 0.75) {
        const translateY = window.innerHeight * (percent / 100) * speed;

        // when section translates height of the screen fis it to the top of the screen
        if (window.innerHeight / translateY > 2) {
          this.elements.container.style.position = "absolute";
          this.elements.container.style.top = "0px";
          this.elements.container.style.transform = `translateY(-${translateY}px)`;
        }
      }
    }
  );
}
